// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
export function isErrorResponse(response) {
    return response.errorMessage !== undefined;
}
//# sourceMappingURL=Web3Response.js.map